var base = require('../product/base');
var focusHelper = require('../components/focus');
var gtm = require('googletagmanager/tagManager');
var swiper = require('../components/swiper');
const initCarousel = swiper.default;
var location = window.location;
const formFields = require('../formFields/formFields');

/* re-initialize slider on update promotion */
/**
 * observeAndInitCarousel
 * @returns {Object|null} returns observer and disconnects after initializing the carousel or returns null if no initialization is needed
 */
function observeAndInitCarousel() {
    if ($('.swiper-slide').length) {
        initCarousel();
        return null;
    }

    let debounceTimer;

    const observer = new MutationObserver((mutations) => {
        const hasSlides = mutations.some((mutation) => {
            return [...mutation.addedNodes].some((node) => {
                return (
                    node.nodeType === 1 &&
                    (
                        node.matches('.swiper-slide') ||
                        node.querySelector('.swiper-slide')
                    )
                );
            });
        });

        if (!hasSlides) return;

        clearTimeout(debounceTimer);

        debounceTimer = setTimeout(() => {
            initCarousel();
            observer.disconnect();
        }, 100);
    });

    observer.observe(document.body, {
        childList: true,
        subtree: true
    });

    return observer;
}

/**
 * renderApproachingDiscountBanners
 * @param {function} callback - callback function
 * @returns {void}
 */
function renderApproachingDiscountBanners(callback) {
    const $widgets = $('.promotion-widgets');

    $widgets.each(function () {
        const $widget = $(this);
        if ($widget.data('url')) {
            var widgetsUrl = $widget.data('url');
            $.ajax({
                url: widgetsUrl,
                method: 'GET',
                dataType: 'html',
                success: function (data) {
                    if (data === '') {
                        $widgets.hide();
                    } else {
                        var html = $('<div />');
                        html.append(data);
                        $widget.html($(html).find('.promotion-widgets').html()).show();
                        $widgets.show();
                    }
                    if (typeof callback === 'function') {
                        callback();
                    }
                }
            });
        }
    });
}

/**
 * appends params to a url
 * @param {string} url - Original url
 * @param {Object} params - Parameters to append
 * @returns {string} result url with appended parameters
 */
function appendToUrl(url, params) {
    var newUrl = url;
    newUrl += (newUrl.indexOf('?') !== -1 ? '&' : '?') + Object.keys(params).map(function (key) {
        return key + '=' + encodeURIComponent(params[key]);
    }).join('&');

    return newUrl;
}

/**
 * Checks whether the basket is valid. if invalid displays error message and disables
 * checkout button
 * @param {Object} data - AJAX response from the server
 */
function validateBasket(data) {
    // Check if any item is out of stock (has OOS badge)
    var hasOOSItems = false;
    if (data.items && data.items.length > 0) {
        for (var i = 0; i < data.items.length; i++) {
            var item = data.items[i];
            if (item && (item.available === false || (item.custom && item.custom.isInStock === false))) {
                hasOOSItems = true;
                break;
            }
        }
    }

    if (data.valid.error || hasOOSItems) {
        // Disable checkout button - use both class and attribute for maximum compatibility
        $('.checkout-btn').addClass('disabled');
        $('.checkout-btn').attr('disabled', 'disabled');
        if (hasOOSItems) {
            var oosHtml = '<div class="alert alert-error alert-error--bg-critical mk-rounded-3 p-3 alert-dismissible valid-cart-error fade show" role="alert">'
                + '<strong class="title mb-1 font-weight-xbold small d-block">Bag Update Needed</strong>'
                + '<p class="m-0 small mk-text-color-black">One or more items in your bag are currently out of stock. Please remove these items to proceed with checkout.</p>'
                + '</div>';
            $('.cart-error').empty().append(oosHtml);
        } else if (data.valid.message) {
            var errorHtml = '<div class="alert alert-error alert-error--bg-critical mk-rounded-3 p-3 alert-dismissible valid-cart-error '
                + 'fade show" role="alert">'
                + '<button type="button" class="close" data-dismiss="alert" aria-label="Close">'
                + '<span aria-hidden="true">&times;</span>'
                + '</button>'
                + '<p class="m-0 small mk-text-color-black">' + data.valid.message + '</p>'
                + '</div>';

            if ($('.cart-error').length) {
                $('.cart-error').empty().append(errorHtml);
            }
        } else if (data.resources && data.resources.emptyCartMsg) {
            $('.cart').empty().append('<div class="row"> '
                + '<div class="col-12 text-center"> '
                + '<h1>' + data.resources.emptyCartMsg + '</h1> '
                + '</div> '
                + '</div>');
            $('.number-of-items').empty().append(data.resources.numberOfItems);
            $('.minicart-quantity').empty().append(data.numItems);
            $('.minicart-link').attr({
                'aria-label': data.resources.minicartCountOfItems,
                title: data.resources.minicartCountOfItems
            });
            $('.minicart .popover').empty();
            $('.minicart .popover').removeClass('show');
        }
    } else {
        // Only enable checkout if BOTH valid.error is false AND no OOS items exist
        var isDisabled = $('.checkout-btn').attr('disabled');
        if (isDisabled === 'disabled') {
            $('.checkout-btn').removeAttr('disabled');
        }
        $('.checkout-btn').removeClass('disabled');
        $('.cart-error').empty();
    }
}

/**
 * re-renders the order totals and the number of items in the cart
 * @param {Object} data - AJAX response from the server
 */
function updateCartTotals(data) {
    if (data.resources) {
        $('.number-of-items').empty().append(data.resources.numberOfItems);
        $('.minicart-link').attr({
            'aria-label': data.resources.minicartCountOfItems,
            title: data.resources.minicartCountOfItems
        });
    }
    $('.order-discount').addClass('hide-order-discount');
    $('.shipping-discount').addClass('hide-shipping-discount');
    if (data.totals) {
        $('.shipping-cost').empty().append(data.totals.totalShippingCost);
        $('.tax-total').empty().append(data.totals.totalTax);
        $('.grand-total').empty().append(data.totals.cartGrandTotal);
        $('.sub-total').empty().append(data.totals.subTotal);
        $('.minicart-quantity').empty().append(data.numItems);
        if (data.totals.orderLevelDiscountTotal.value > 0) {
            $('.order-discount').removeClass('hide-order-discount');
            $('.order-discount-total').empty()
                .append('- ' + data.totals.orderLevelDiscountTotal.formatted);
        }
        if (data.totals.shippingLevelDiscountTotal.value > 0) {
            $('.shipping-discount').removeClass('hide-shipping-discount');
            $('.shipping-discount-total').empty().append('- '
                + data.totals.shippingLevelDiscountTotal.formatted);
        }
    }
    if (data.items) {
        data.items.forEach(function (item) {
            if (data.totals.orderLevelDiscountTotal.value > 0) {
                $('.coupons-and-promos').empty().append(data.totals.discountsHtml);
            }
            if (item.renderedPromotions) {
                $('.item-' + item.UUID).empty().append(item.renderedPromotions);
            } else {
                $('.item-' + item.UUID).empty();
            }
            $('.uuid-' + item.UUID + ' .unit-price').empty().append(item.renderedPrice);
            $('.line-item-price-' + item.UUID + ' .unit-price').empty().append(item.renderedPrice);
            $('.item-total-' + item.UUID).empty().append(item.priceTotal.renderedPrice);
        });
    }
}

/**
 * re-renders the order totals and the number of items in the cart
 * @param {Object} message - Error message to display
 */
function createErrorNotification(message) {
    var errorHtml = '<div class="alert alert-error alert-error--bg-critical mk-rounded-3 p-3 alert-dismissible valid-cart-error '
        + 'fade show" role="alert">'
        + '<button type="button" class="close" data-dismiss="alert" aria-label="Close">'
        + '<span aria-hidden="true">&times;</span>'
        + '</button>'
        + '<p class="m-0 small mk-text-color-black">' + message + '</p>'
        + '</div>';

    $('.cart-error').append(errorHtml);
}

/**
 * @param {Object} approachingDiscounts - array of approaching discounts to check if banners need to be re-rendered
 * @param {Object} totals - the current totals object to check if banners need to be re-rendered
 * re-renders the approaching discount messages
 */
function updateApproachingDiscounts(approachingDiscounts, totals) {
    var renderBanners = (approachingDiscounts && approachingDiscounts.length > 0) || (totals && totals.shouldRenderPromotionBanners);
    if (renderBanners) {
        renderApproachingDiscountBanners(function () {
            observeAndInitCarousel();
        });
    } else if ($('.promotion-widgets').length > 0) {
        var $promotionWidgets = $('.promotion-widgets');
        $promotionWidgets.empty();
        $promotionWidgets.hide();
    }
}

/**
 * Updates the availability of a product line item
 * @param {Object} data - AJAX response from the server
 * @param {string} uuid - The uuid of the product line item to update
 */
function updateAvailability(data, uuid) {
    var lineItem;
    var messages = '';

    for (var i = 0; i < data.items.length; i++) {
        if (data.items[i].UUID === uuid) {
            lineItem = data.items[i];
            break;
        }
    }

    if (lineItem != null) {
        $('.availability-' + lineItem.UUID).empty();

        if (lineItem.availability) {
            if (lineItem.availability.messages) {
                lineItem.availability.messages.forEach(function (message) {
                    messages += '<p class="line-item-attributes">' + message + '</p>';
                });
            }

            if (lineItem.availability.inStockDate) {
                messages += '<p class="line-item-attributes line-item-instock-date">'
                    + lineItem.availability.inStockDate
                    + '</p>';
            }
        }

        $('.availability-' + lineItem.UUID).html(messages);
    }
}

/**
 * Finds an element in the array that matches search parameter
 * @param {array} array - array of items to search
 * @param {function} match - function that takes an element and returns a boolean indicating if the match is made
 * @returns {Object|null} - returns an element of the array that matched the query.
 */
function findItem(array, match) { // eslint-disable-line no-unused-vars
    for (var i = 0, l = array.length; i < l; i++) {
        if (match.call(this, array[i])) {
            return array[i];
        }
    }
    return null;
}

/**
 * Updates details of a product line item
 * @param {Object} data - AJAX response from the server
 * @param {string} uuid - The uuid of the product line item to update
 */
function updateProductDetails(data, uuid) {
    $('.card.product-info.uuid-' + uuid).replaceWith(data.renderedTemplate);
}

/**
 * Generates the modal window on the first call.
 *
 */
function getModalHtmlElement() {
    if ($('#editProductModal').length !== 0) {
        $('#editProductModal').remove();
    }
    var htmlString = '<!-- Modal -->'
        + '<div class="modal fade" id="editProductModal" tabindex="-1" role="dialog">'
        + '<span class="enter-message sr-only" ></span>'
        + '<div class="modal-dialog quick-view-dialog">'
        + '<!-- Modal content-->'
        + '<div class="modal-content">'
        + '<div class="modal-header">'
        + '    <button type="button" class="close pull-right" data-dismiss="modal">'
        + '        <span aria-hidden="true">&times;</span>'
        + '        <span class="sr-only"> </span>'
        + '    </button>'
        + '</div>'
        + '<div class="modal-body"></div>'
        + '<div class="modal-footer"></div>'
        + '</div>'
        + '</div>'
        + '</div>';
    $('body').append(htmlString);
}

/**
 * Parses the html for a modal window
 * @param {string} html - representing the body and footer of the modal window
 *
 * @return {Object} - Object with properties body and footer.
 */
function parseHtml(html) {
    var $html = $('<div>').append($.parseHTML(html));

    var body = $html.find('.product-quickview');
    var footer = $html.find('.modal-footer').children();

    return { body: body, footer: footer };
}

/**
 * replaces the content in the modal window for product variation to be edited.
 * @param {string} editProductUrl - url to be used to retrieve a new product model
 */
function fillModalElement(editProductUrl) {
    $('.modal-body').spinner().start();
    $.ajax({
        url: editProductUrl,
        method: 'GET',
        dataType: 'json',
        success: function (data) {
            var parsedHtml = parseHtml(data.renderedTemplate);

            $('#editProductModal .modal-body').empty();
            $('#editProductModal .modal-body').html(parsedHtml.body);
            $('#editProductModal .modal-footer').html(parsedHtml.footer);
            $('#editProductModal .modal-header .close .sr-only').text(data.closeButtonText);
            $('#editProductModal .enter-message').text(data.enterDialogMessage);
            $('#editProductModal').modal('show');
            $('body').trigger('editproductmodal:ready');
            $.spinner().stop();
        },
        error: function () {
            $.spinner().stop();
        }
    });
}

/**
 * replace content of modal
 * @param {string} actionUrl - url to be used to remove product
 * @param {string} productID - pid
 * @param {string} productName - product name
 * @param {string} uuid - uuid
 */
function confirmDelete(actionUrl, productID, productName, uuid) {
    var $deleteConfirmBtn = $('.cart-delete-confirmation-btn');
    var $productToRemoveSpan = $('.product-to-remove');

    $deleteConfirmBtn.data('pid', productID);
    $deleteConfirmBtn.data('action', actionUrl);
    $deleteConfirmBtn.data('uuid', uuid);

    $productToRemoveSpan.empty().append(productName);
}

/**
 * Enables or disables the quantity increment and decrement buttons
 * based on the current quantity and the min/max limits.
 *
 * - Resets both plus and minus buttons to enabled state if quantity is between max and min.
 * - Disables the plus button if quantity is at or above max.
 * - Disables the minus button if quantity is at or below min.
 *
 * @param {jQuery} elem - The container element that wraps the quantity input and control buttons.
 * @param {number} qty - The current quantity selected by the user.
 */
function disableQuantityBtns(elem, qty) {
    const $quantityInput = elem.find('.quantity');
    const maxVal = parseInt($quantityInput.attr('max'), 10);
    const minVal = parseInt($quantityInput.attr('min'), 10);

    const buttons = {
        plus: elem.find('.button-plus'),
        minus: elem.find('.button-minus')
    };

    if (!Number.isNaN(maxVal) && qty >= maxVal) {
        buttons.plus.addClass('disable').prop('disabled', true).attr('aria-disabled', true);
        buttons.minus.removeClass('disable').prop('disabled', false).attr('aria-disabled', false);
    } else if (!Number.isNaN(minVal) && qty <= minVal) {
        buttons.minus.addClass('disable').prop('disabled', true).attr('aria-disabled', true);
        buttons.plus.removeClass('disable').prop('disabled', false).attr('aria-disabled', false);
    } else {
        buttons.minus.removeClass('disable').prop('disabled', false).attr('aria-disabled', false);
        buttons.plus.removeClass('disable').prop('disabled', false).attr('aria-disabled', false);
    }
}

/**
 * returns the localized value for the quantity label
 * @param {jquery} $elem - field element
 * @returns {string} returns label of quantity
 */
function getQuantityLabelPrefix($elem) {
    var prefix = $elem.data('aria-label-prefix');
    if (prefix) {
        return prefix;
    }
    var inputId = $elem.attr('id');
    var $container = $elem.closest('.quantity-form').parent();
    var $label = $container.find('label[for="' + inputId + '"]').first();
    if ($label.length && $label.text().trim()) {
        return $label.text().trim();
    }

    var existingLabel = $elem.attr('aria-label');
    if (existingLabel && existingLabel.indexOf(':') !== -1) {
        return existingLabel.substring(0, existingLabel.lastIndexOf(':')).trim();
    }

    return 'Quantity';
}

/**
 *  network call to make after quantity is updated
 * @param {jquery} elem - jquery element
 */
function updateQuantity(elem) {
    var $elem = elem;
    var preSelectQty = $elem.data('pre-select-qty');
    var quantity = $elem.val();
    var productID = $elem.data('pid');
    var url = $elem.data('action');
    var uuid = $elem.data('uuid');
    var $parentElm = $elem.closest('.quantity-form');
    var quantityLabelPrefix = getQuantityLabelPrefix($elem);
    var urlParams = {
        pid: productID,
        quantity: quantity,
        uuid: uuid
    };
    url = appendToUrl(url, urlParams);

    $elem.parents('.card').spinner().start();

    $('body').trigger('cart:beforeUpdate');

    $.ajax({
        url: url,
        type: 'get',
        context: $elem[0],
        dataType: 'json',
        success: function (data) {
            $('.ibc-negative-profit-message').remove();
            $('.quantity[data-uuid="' + uuid + '"]').val(quantity);
            $('.coupons-and-promos').empty().append(data.totals.discountsHtml);
            var $liveRegion = $parentElm.find('.qty-live-region');
            $liveRegion.text(quantityLabelPrefix + ': ' + quantity);
            if (data && data.gtm && data.gtm.data) {
                var qtyDiff = data.gtm.newQty - data.gtm.oldQty;
                if (qtyDiff > 0) {
                    gtm.addToCart(data.gtm.data, qtyDiff);
                } else {
                    gtm.removeFromCart(data.gtm.data, Math.abs(qtyDiff));
                }
            }
            updateCartTotals(data);
            updateApproachingDiscounts(data.approachingDiscounts, data.totals);
            updateAvailability(data, uuid);
            validateBasket(data);
            $elem.data('pre-select-qty', quantity);

            $('body').trigger('cart:update', data);

            $.spinner().stop();
            if (
                !$('.mini-cart-tray.tray-popup-visible').length &&
                (($elem.parents('.product-info').hasClass('bonus-product-line-item') && $('.cart-page').length) ||
                    data.hasBonusProduct)
            ) {
                location.reload();
            }
        },
        error: function (err) {
            if (err.responseJSON.redirectUrl) {
                window.location.href = err.responseJSON.redirectUrl;
            } else {
                createErrorNotification(err.responseJSON.errorMessage);
                $elem.val(parseInt(preSelectQty, 10));
                $.spinner().stop();
            }
        }
    });
}

/**
 * Gets the FAQ category headline text for the accordion button, falling back to the nearest preceding section title.
 * @param {jQuery} $btn - The button element to start the search from.
 * @returns {string} The trimmed category title, or an empty string if none found.
 */
function getCategoryTitle($btn) {
    var faq = $btn.closest('.pxp-faq-component').find('.pxp-faq-category-headline').first().text().trim();
    if (faq) {
        return faq;
    }
    return $btn.closest('.layout-content, .grid-region')
        .prevAll('.layout-section-title')
        .first()
        .find('.layout-section-title-text')
        .text()
        .trim();
}

/**
 * Sends the product ID to the server and fetches the product data object.
 *
 * @function getProductDataObject
 * @param {string} pid - The product ID to fetch details for.
 * @returns {jqXHR} - jQuery promise object for the AJAX request.
 */
function getProductDataObject(pid) {
    var url = $('#getMatchProductUrl').val();

    return $.ajax({
        url: url,
        type: 'post',
        dataType: 'json',
        data: {
            pid: pid,
            csrf_token: $('[name="csrf_token"]').val()
        }
    });
}

module.exports = function () {
    $('body').on('click', '.remove-product:not(.minicart-delete)', function (e) {
        e.preventDefault();
        var $this = $(this);
        var actionUrl = $this.data('action');
        var productID = $this.data('pid');
        var productName = $this.data('name');
        var uuid = $this.data('uuid');
        var isMinicart = $this.parents('.remove-line-item').attr('data-isminicart');
        if (!isMinicart) {
            confirmDelete(actionUrl, productID, productName, uuid);
        }
    });

    $('body').on('afterRemoveFromCart', function (e, data) {
        e.preventDefault();
        confirmDelete(data.actionUrl, data.productID, data.productName, data.uuid);
    });

    $('.optional-promo').click(function (e) {
        e.preventDefault();
        $('.promo-code-form').toggle();
    });

    $('body').on('tray:closed', function (e, response) {
        if ($(response).hasClass('mini-cart-tray')) {
            gtm.closeMinicart();
        }
    });

    $('body').on('click', '.mirror-me-js', function () {
        var pid = $('.product-detail.product-wrapper').data('pid');
        getProductDataObject(pid).done(function (response) {
            gtm.tryItOn(response.productData);
        });
    });

    $('body').on('click', '.find-my-match-js', function () {
        var pid = $('.product-detail.product-wrapper').data('pid');
        getProductDataObject(pid).done(function (response) {
            gtm.findMyMatch(response.productData);
        });
    });

    $('.product-details-accordion .card-header button').on('click', function () {
        var accordionName = $(this).find('.col-10').text().trim();
        gtm.productAccordionClick(accordionName);
    });
    $('.pxp-faq-component .pxp-faq-accordion .card-header button').on('click', function () {
        var $button = $(this);
        var isCurrentlyCollapsed = $button.hasClass('collapsed');
        var expandOrCollapse = isCurrentlyCollapsed ? 'expand' : 'collapse';
        var sectionType = getCategoryTitle($button);
        var sectionName = $button
            .find('.faq-question-text')
            .text()
            .trim();
        gtm.productAccordionInteraction(expandOrCollapse, sectionType, sectionName);
    });
    $('body').on('click', '.cart-delete-confirmation-btn, .minicart-delete.remove-product ', function (e) {
        e.preventDefault();
        var isMinicart = false;
        if($(e.currentTarget).hasClass('minicart-delete')) {
            isMinicart = true
        }
        var productID = $(this).data('pid');
        var url = $(this).data('action');
        var uuid = $(this).data('uuid');
        var urlParams = {
            pid: productID,
            uuid: uuid
        };

        url = appendToUrl(url, urlParams);

        $('body > .modal-backdrop').remove();

        $.spinner().start();

        $('body').trigger('cart:beforeUpdate');

        $.ajax({
            url: url,
            type: 'get',
            dataType: 'json',
            success: function (data) {
                $('.ibc-negative-profit-message').remove();
                if (data.basket.items.length === 0) {
                    $('.cart').empty();
                    $('.cart-cart__empty').removeClass('d-none');
                    $('.mini-cart-cart__empty').removeClass('d-none').addClass('d-flex');
                    $('.number-of-items').empty().append(data.basket.resources.numberOfItems);
                    const $minicartQuantity = $('.minicart-quantity')
                    if (data.basket.numItems > 0) {
                        $minicartQuantity.empty().append(data.basket.numItems)
                    } else {
                        $minicartQuantity.empty();
                        $('.minicart .minicart-icon-text').removeClass('active');
                    }

                    var minicartLiveRegion = $('.mini-cart-tray').find('.minicart-live-region');
                    if (minicartLiveRegion.length) {
                        var emptyCartMsg = minicartLiveRegion.data('empty-msg');
                        minicartLiveRegion.text('');
                        setTimeout(function () {
                            minicartLiveRegion.text(emptyCartMsg);
                        }, 100);
                    }

                    var liveRegion = document.querySelector('.cart-live-region');
                    if (liveRegion) {
                        var emptyMessage = liveRegion.getAttribute('data-empty-msg');
                        liveRegion.textContent = '';
                        setTimeout(function () {
                            liveRegion.textContent = emptyMessage;
                        }, 100);
                    }

                    $('.minicart-link').attr({
                        'aria-label': data.basket.resources.minicartCountOfItems,
                        title: data.basket.resources.minicartCountOfItems
                    });
                    $('.promotion-widgets').empty();
                    $('.minicart .popover').empty();
                    $('.minicart .popover').removeClass('show');
                    $('body').removeClass('modal-open');
                    $('html').removeClass('veiled');
                    gtm.removeFromCart(data.productData, data.productData.quantity);
                } else {
                    if (data.toBeDeletedUUIDs && data.toBeDeletedUUIDs.length > 0) {
                        for (var i = 0; i < data.toBeDeletedUUIDs.length; i++) {
                            $('.uuid-' + data.toBeDeletedUUIDs[i]).remove();
                        }
                    }
                    if(isMinicart) {
                        $('.uuid-' + uuid).parents('.minicart-product-container').remove();
                    } else {
                        $('.uuid-' + uuid).remove();
                    }
                    if (!data.basket.hasBonusProduct) {
                        $('.bonus-product').remove();
                    }
                    $('.coupons-and-promos').empty().append(data.basket.totals.discountsHtml);
                    updateCartTotals(data.basket);
                    gtm.removeFromCart(data.productData, data.productData.quantity);
                    updateApproachingDiscounts(data.basket.approachingDiscounts, data.basket.totals);
                    $('body').trigger('setShippingMethodSelection', data.basket);
                    validateBasket(data.basket);
                }

                data.forceMiniCartRefresh = isMinicart;  // eslint-disable-line no-param-reassign
                $('body').trigger('cart:update', data);
                if (!$('.mini-cart-tray.tray-popup-visible').length &&
                    (($(this).parents('.product-info').hasClass('bonus-product-line-item') && $('.cart-page').length) ||
                    data.basket.hasBonusProduct)) {
                    location.reload();
                }

                $.spinner().stop();
                if (data.basket.numItems === 0) {
                    setTimeout(function () {
                        var btn = $('.close-btn>.tray-popup-close').filter(':visible').first();
                        if (btn.length) {
                            btn[0].focus();
                        }
                    }, 100);
                }
            },
            error: function (err) {
                if (err.responseJSON.redirectUrl) {
                    window.location.href = err.responseJSON.redirectUrl;
                } else {
                    createErrorNotification(err.responseJSON.errorMessage);
                    $.spinner().stop();
                }
            }
        });
    });
    $('body').on('click', '.quantity-form > .button-plus', function () {
        var parentElm = $(this).parents('.quantity-form');
        const $qtyInput = parentElm.find('.quantity');
        const qtyInputData = $qtyInput.data();
        var prefix = getQuantityLabelPrefix($qtyInput);
        let $this = $(this);
        $this.addClass('clicked');
        setTimeout(function () {
            $('.clicked').removeClass('clicked');
        }, 100);
        var quantity = $qtyInput.val();
        var maxVal = parseInt($qtyInput.attr('max'), 10);
        var parsedQty = parseInt(quantity, 10);
        if (parsedQty < maxVal) {
            parsedQty++;
            $qtyInput.val(parsedQty);
            $qtyInput.attr('aria-label', prefix + ': ' + parsedQty);
            $(this).removeClass('disable');
            $(this).prop('disabled', false);
        }
        disableQuantityBtns(parentElm, parsedQty);
        if (qtyInputData.updateCart !== false) {
            updateQuantity($(this).parent().find('.quantity'));
        }
    });
    // Decrease product quantity on cart page
    $('body').on('click', '.quantity-form > .button-minus', function () {
        var parentElm = $(this).parents('.quantity-form');
        const $qtyInput = parentElm.find('.quantity');
        const qtyInputData = $qtyInput.data();
        var prefix = getQuantityLabelPrefix($qtyInput);

        $(this).addClass('clicked');
        setTimeout(function () {
            $('.clicked').removeClass('clicked');
        }, 100);
        var quantity = $qtyInput.val();
        var minVal = parseInt($qtyInput.attr('min'), 10);
        var parsedQty = parseInt(quantity, 10);
        if (parsedQty > minVal) {
            parsedQty--;
            $qtyInput.val(parsedQty);
            $qtyInput.attr('aria-label', prefix + ': ' + parsedQty);
            $(this).removeClass('disable');
            $(this).prop('disabled', false);
        }
        disableQuantityBtns(parentElm, parsedQty);

        if (qtyInputData.updateCart !== false) {
            updateQuantity($(this).parent().find('.quantity'));
        }
    });
    $('body').on('change', '.quantity-form > .quantity', function () {
        updateQuantity($(this));
    });

    $('.shippingMethods').change(function () {
        var url = $(this).attr('data-actionUrl');
        var urlParams = {
            methodID: $(this).find(':selected').attr('data-shipping-id')
        };
        // url = appendToUrl(url, urlParams);

        $('.totals').spinner().start();
        $('body').trigger('cart:beforeShippingMethodSelected');
        $.ajax({
            url: url,
            type: 'post',
            dataType: 'json',
            data: urlParams,
            success: function (data) {
                if (data.error) {
                    window.location.href = data.redirectUrl;
                } else {
                    $('.coupons-and-promos').empty().append(data.totals.discountsHtml);
                    updateCartTotals(data);
                    updateApproachingDiscounts(data.approachingDiscounts, data.totals);
                    validateBasket(data);
                }

                $('body').trigger('cart:shippingMethodSelected', data);
                $.spinner().stop();
            },
            error: function (err) {
                if (err.redirectUrl) {
                    window.location.href = err.redirectUrl;
                } else {
                    createErrorNotification(err.responseJSON.errorMessage);
                    $.spinner().stop();
                }
            }
        });
    });

    $('.promo-code-form').submit(function (e) {
        e.preventDefault();
        $.spinner().start();
        $('.coupon-missing-error').hide();
        $('.coupon-error-message').empty();
        var couponCode = $('.coupon-code-field').val();
        if (!$('.coupon-code-field').val()) {
            $('.promo-code-form .form-control').addClass('is-invalid');
            $('.promo-code-form .form-control').attr('aria-describedby', 'missingCouponCode');
            $('.coupon-missing-error').show();
            $.spinner().stop();
            return false;
        }
        var $form = $('.promo-code-form');
        $('.promo-code-form .form-control').removeClass('is-invalid');
        $('.coupon-error-message').empty();
        $('body').trigger('promotion:beforeUpdate');

        $.ajax({
            url: $form.attr('action'),
            type: 'GET',
            dataType: 'json',
            data: $form.serialize(),
            success: function (data) {
                if (data.error) {
                    $('.promo-code-form .form-control').addClass('is-invalid');
                    $('.promo-code-form .form-control').attr('aria-describedby', 'invalidCouponCode');
                    $('.coupon-error-message').empty().append(data.errorMessage);
                    $('body').trigger('promotion:error', data);
                    gtm.applyPromoCode(couponCode, 'fail');
                } else {
                    $('.coupons-and-promos').empty().append(data.totals.discountsHtml);
                    updateCartTotals(data);
                    updateApproachingDiscounts(data.approachingDiscounts, data.totals);
                    validateBasket(data);
                    gtm.applyPromoCode(couponCode, 'success');
                    $('body').trigger('promotion:success', data);
                }
                $('.coupon-code-field').val('');
                $.spinner().stop();
            },
            error: function (err) {
                $('body').trigger('promotion:error', err);
                if (err.responseJSON.redirectUrl) {
                    window.location.href = err.responseJSON.redirectUrl;
                } else {
                    createErrorNotification(err.errorMessage);
                    $.spinner().stop();
                }
            }
        });
        return false;
    });

    $('body').on('click', '.remove-coupon', function (e) {
        e.preventDefault();

        var couponCode = $(this).data('code');
        var uuid = $(this).data('uuid');
        var $deleteConfirmBtn = $('.delete-coupon-confirmation-btn');
        var $productToRemoveSpan = $('.coupon-to-remove');

        $deleteConfirmBtn.data('uuid', uuid);
        $deleteConfirmBtn.data('code', couponCode);

        $productToRemoveSpan.empty().append(couponCode);
    });

    $('body').on('click', '.delete-coupon-confirmation-btn', function (e) {
        e.preventDefault();

        var url = $(this).data('action');
        var uuid = $(this).data('uuid');
        var couponCode = $(this).data('code');
        var urlParams = {
            code: couponCode,
            uuid: uuid
        };

        url = appendToUrl(url, urlParams);

        $('body > .modal-backdrop').remove();

        $.spinner().start();
        $('body').trigger('promotion:beforeUpdate');
        $.ajax({
            url: url,
            type: 'get',
            dataType: 'json',
            success: function (data) {
                $('.coupon-uuid-' + uuid).remove();
                updateCartTotals(data);
                updateApproachingDiscounts(data.approachingDiscounts, data.totals);
                validateBasket(data);
                gtm.removePromoCode(couponCode, 'success');
                $.spinner().stop();
                $('body').trigger('promotion:success', data);
            },
            error: function (err) {
                $('body').trigger('promotion:error', err);
                gtm.removePromoCode(couponCode, 'fail');
                if (err.responseJSON.redirectUrl) {
                    window.location.href = err.responseJSON.redirectUrl;
                } else {
                    createErrorNotification(err.responseJSON.errorMessage);
                    $.spinner().stop();
                }
            }
        });
    });
    $('body').on('click', '.cart-page .bonus-product-button', function () {
        $.spinner().start();
        $(this).addClass('launched-modal');
        $.ajax({
            url: $(this).data('url'),
            method: 'GET',
            dataType: 'json',
            success: function (data) {
                base.methods.editBonusProducts(data);
                $.spinner().stop();
            },
            error: function () {
                $.spinner().stop();
            }
        });
    });

    $('body').on('hidden.bs.modal', '#chooseBonusProductModal', function () {
        $('#chooseBonusProductModal').remove();
        $('.modal-backdrop').remove();
        $('body').removeClass('modal-open');

        if ($('.cart-page').length) {
            $('.launched-modal .btn-outline-primary').trigger('focus');
            $('.launched-modal').removeClass('launched-modal');
        } else {
            $('.product-detail .add-to-cart').focus();
        }
    });

    $('body').on('click', '.cart-page .product-edit .edit, .cart-page .bundle-edit .edit', function (e) {
        e.preventDefault();

        var editProductUrl = $(this).attr('href');
        getModalHtmlElement();
        fillModalElement(editProductUrl);
    });

    $('body').on('shown.bs.modal', '#editProductModal', function () {
        $('#editProductModal').siblings().attr('aria-hidden', 'true');
        $('#editProductModal .close').focus();
    });

    $('body').on('hidden.bs.modal', '#editProductModal', function () {
        $('#editProductModal').siblings().attr('aria-hidden', 'false');
    });

    $('body').on('keydown', '#editProductModal', function (e) {
        var focusParams = {
            event: e,
            containerSelector: '#editProductModal',
            firstElementSelector: '.close',
            lastElementSelector: '.update-cart-product-global',
            nextToLastElementSelector: '.modal-footer .quantity-select'
        };
        focusHelper.setTabNextFocus(focusParams);
    });

    $('body').on('product:updateAddToCart', function (e, response) {
        // update global add to cart (single products, bundles)
        var dialog = $(response.$productContainer)
            .closest('.quick-view-dialog');

        $('.update-cart-product-global', dialog).attr(
            'disabled',
            !$('.global-availability', dialog).data('ready-to-order')
            || !$('.global-availability', dialog).data('available')
        );
    });

    $('body').on('product:updateAvailability', function (e, response) {
        // bundle individual products
        $('.product-availability', response.$productContainer)
            .data('ready-to-order', response.product.readyToOrder)
            .data('available', response.product.available)
            .find('.availability-msg')
            .empty()
            .html(response.message);

        var dialog = $(response.$productContainer)
            .closest('.quick-view-dialog');

        if ($('.product-availability', dialog).length) {
            // bundle all products
            var allAvailable = $('.product-availability', dialog).toArray()
                .every(function (item) { return $(item).data('available'); });

            var allReady = $('.product-availability', dialog).toArray()
                .every(function (item) { return $(item).data('ready-to-order'); });

            $('.global-availability', dialog)
                .data('ready-to-order', allReady)
                .data('available', allAvailable);

            $('.global-availability .availability-msg', dialog).empty()
                .html(allReady ? response.message : response.resources.info_selectforstock);
        } else {
            // single product
            $('.global-availability', dialog)
                .data('ready-to-order', response.product.readyToOrder)
                .data('available', response.product.available)
                .find('.availability-msg')
                .empty()
                .html(response.message);
        }
    });

    $('body').on('product:afterAttributeSelect', function (e, response) {
        if ($('.modal.show .product-quickview .bundle-items').length) {
            $('.modal.show').find(response.container).data('pid', response.data.product.id);
            $('.modal.show').find(response.container).find('.product-id').text(response.data.product.id);
        } else {
            $('.modal.show .product-quickview').data('pid', response.data.product.id);
        }
    });

    $('body').on('change', '.quantity-select', function () {
        var selectedQuantity = $(this).val();
        $('.modal.show .update-cart-url').data('selected-quantity', selectedQuantity);
    });

    $('body').on('change', '.options-select', function () {
        var selectedOptionValueId = $(this).children('option:selected').data('value-id');
        $('.modal.show .update-cart-url').data('selected-option', selectedOptionValueId);
    });

    $('body').on('click', '.update-cart-product-global', function (e) {
        e.preventDefault();

        var updateProductUrl = $(this).closest('.cart-and-ipay').find('.update-cart-url').val();
        var selectedQuantity = $(this).closest('.cart-and-ipay').find('.update-cart-url').data('selected-quantity');
        var selectedOptionValueId = $(this).closest('.cart-and-ipay').find('.update-cart-url').data('selected-option');
        var uuid = $(this).closest('.cart-and-ipay').find('.update-cart-url').data('uuid');

        var form = {
            uuid: uuid,
            pid: base.getPidValue($(this)),
            quantity: selectedQuantity,
            selectedOptionValueId: selectedOptionValueId
        };

        $(this).parents('.card').spinner().start();

        $('body').trigger('cart:beforeUpdate');

        if (updateProductUrl) {
            $.ajax({
                url: updateProductUrl,
                type: 'post',
                context: this,
                data: form,
                dataType: 'json',
                success: function (data) {
                    $('#editProductModal').modal('hide');

                    $('.coupons-and-promos').empty().append(data.cartModel.totals.discountsHtml);
                    updateCartTotals(data.cartModel);
                    updateApproachingDiscounts(data.cartModel.approachingDiscounts, data.cartModel.totals);
                    updateAvailability(data.cartModel, uuid);
                    updateProductDetails(data, uuid);

                    if (data.uuidToBeDeleted) {
                        $('.uuid-' + data.uuidToBeDeleted).remove();
                    }

                    validateBasket(data.cartModel);

                    $('body').trigger('cart:update', data);

                    $.spinner().stop();
                },
                error: function (err) {
                    if (err.responseJSON.redirectUrl) {
                        window.location.href = err.responseJSON.redirectUrl;
                    } else {
                        createErrorNotification(err.responseJSON.errorMessage);
                        $.spinner().stop();
                    }
                }
            });
        }
    });

    $('body').on('click', '.checkout-btn', function () {
        gtm.updateCheckoutStep();
    });

    $('.line-item-name').on('keydown', function (e) {
        if (e.key === 'Enter') {
            e.preventDefault();
            var $link = $(this).find('a');
            if ($link.length && $link.attr('href')) {
                window.location.href = $link.attr('href');
            }
        }
    });

    $('.minicart .minicart-link').on('click', function () {
        setTimeout(function () {
            if ($('.swiper-slide').length) {
                initCarousel();
            } else {
                observeAndInitCarousel();
            }
        }, 2500);
    });

    var config = {
        childList: true,
        subtree: true
    };

    var hasInitialized = false;
    var debounceTimer = null;

    var observer = new MutationObserver(function (mutations) {
        if (hasInitialized) return;

        $.each(mutations, function (_, mutation) {
            if (mutation.type !== 'childList' || !mutation.addedNodes.length) return;

            mutation.addedNodes.forEach(function (node) {
                if (node.nodeType !== 1) return false;

                var slot = node.closest('[id^="cq_recomm_slot-"]');
                if (!slot) return false;

                if (node.classList.contains('swiper-slide') || node.querySelector('.swiper-slide')) {
                    clearTimeout(debounceTimer);

                    debounceTimer = setTimeout(function () {
                        if (hasInitialized) return;

                        hasInitialized = true;
                        initCarousel();

                        // Stop observing once initialized
                        observer.disconnect();
                    }, 100);

                    return false; // break .each()
                }
                return true;
            });

        });
    });

    $(document).ready(function () {
        // Observe all matching elements (unwrap jQuery → DOM)
        if ($('[id^="cq_recomm_slot-"]').length) {
            observer.observe(document.body, config);
        }
    });

    // AC5: reload cart page when bonus PLI count changes after any basket mutation
    /**
     * Reloads the cart page or refreshes the open mini-cart when server item count differs from DOM.
     * @param {Object} data - AJAX response data from any cart mutation
     */
    function syncBonusItems(data) {
        var items = (data && data.cart && data.cart.items)
            || (data && data.basket && data.basket.items)
            || (data && data.items)
            || null;
        if (!items) { return; }

        if ($('.cart-page').length) {
            if (items.length !== $('.cart-left-section .card.product-info').length) {
                location.reload();
            }
            return;
        }

        // Mini-cart tray: refresh product list in place when item count changes
        // .last() is used to get the last product-summary and update the item count.
        var $productSummary = $('.mk-mini-cart .product-summary').last();
        if (!$productSummary.length) { return; }
        var hasReplacedItems = items.some(function (item) {
            return item.UUID && !$productSummary.find('.uuid-' + item.UUID).length;
        });
        if (data.forceMiniCartRefresh || items.length !== $productSummary.find('.minicart-product-container').length || hasReplacedItems) {
            var url = $('.minicart-link[data-ajax-content]').data('ajax-content');
            if (!url) { return; }
            $.spinner().start();
            $.get(url)
                .done(function (html) {
                    var $freshSummary = $(html).find('.product-summary');
                    if ($freshSummary.length) {
                        $productSummary.html($freshSummary.html());
                        formFields.updateSelect();
                        $('body').trigger('miniCart:updated', {
                            source: 'cart:syncBonusItems'
                        });
                    }
                })
                .always(function () {
                    $.spinner().stop();
                });
        }
    }

    $('body').on('product:afterAddToCart', function (e, data) {
        syncBonusItems(data);
    });

    $('body').on('cart:update', function (e, data) {
        syncBonusItems(data);
    });

    $(document).on('click', '.add-choice-bonus-products', function () {
        var url = $(this).data('addtocarturl');
        $.spinner().start();
        $.ajax({
            url: url,
            method: 'POST',
            success: function (data) {
                $.spinner().stop();
                if (data.error) {
                    if ($('.add-to-cart-messages').length === 0) {
                        $('body').append('<div class="add-to-cart-messages"></div>');
                    }
                    $('.add-to-cart-messages').append(
                        '<div class="alert alert-danger add-to-basket-alert text-center"'
                        + ' role="alert">'
                        + data.errorMessage + '</div>'
                    );
                    setTimeout(function () {
                        $('.add-to-basket-alert').remove();
                    }, 3000);
                } else {
                    if ($('.add-to-cart-messages').length === 0) {
                        $('body').append('<div class="add-to-cart-messages message-position-bottom"></div>');
                    }
                    $('.minicart-quantity').html(data.totalQty);
                    updateCartTotals(data.cart);
                    updateApproachingDiscounts(data.cart.approachingDiscounts, data.cart.totals);
                    $('body').trigger('cart:update', data);

                    $('.add-to-cart-messages').html(
                        '<div class="alert alert-success add-to-basket-alert add-bonus-product-alert text-center"'
                        + ' role="alert">'
                        + '<img class="icon gif-box" src="' + window.STATIC_URL + '/images/gift-box.png" alt=""/>'
                        + data.msgSuccess + '</div>'
                    );
                    setTimeout(function () {
                        $('.add-to-basket-alert').remove();
                        if ($('.cart-page').length) {
                            window.location.reload();
                        }
                    }, 5000);
                }
            },
            error: function () {
                $.spinner().stop();
            }
        });
    });

    $('body').on('change', '.quantity-bonus-product', function () {
        var $elem = $(this);
        var preSelectQty = $elem.data('pre-select-qty');
        var quantity = parseInt($elem.val(), 10);
        var productID = $elem.data('pid');
        var url = $elem.data('action');
        var uuid = $elem.data('uuid');
        var pliuuid = $elem.data('pliuuid');
        var queryString = '?pids=';
        var pidsObject = {
            bonusProducts: []
        };
        var option = null;
        $.spinner().start();
        if (quantity > 0) {
            if ($(this).data('optionid') && $(this).data('option-selected-value')) {
                option = {};
                option.optionId = $(this).data('optionid');
                option.productId = $(this).data('pid');
                option.selectedValueId = $(this).data('option-selected-value');
            }
            pidsObject.bonusProducts.push({
                pid: productID,
                qty: quantity,
                options: [option]
            });
            pidsObject.totalQty = quantity;
        }
        queryString += JSON.stringify(pidsObject);
        queryString = queryString + '&uuid=' + uuid;
        queryString = queryString + '&pliuuid=' + pliuuid;
        $.ajax({
            url: url + queryString,
            method: 'POST',
            success: function (data) {
                $.spinner().stop();
                if (data.error) {
                    $('#chooseBonusProductModal').modal('hide');
                    if ($('.add-to-cart-messages').length === 0) {
                        $('body').append('<div class="add-to-cart-messages"></div>');
                    }
                    $('.add-to-cart-messages').append(
                        '<div class="alert alert-danger add-to-basket-alert text-center"'
                        + ' role="alert">'
                        + data.errorMessage + '</div>'
                    );
                    setTimeout(function () {
                        $('.add-to-basket-alert').remove();
                    }, 3000);
                } else {
                    updateCartTotals(data.cart);
                    updateApproachingDiscounts(data.cart.approachingDiscounts, data.cart.totals);
                    $('body').trigger('cart:update', data);
                    $elem.data('pre-select-qty', quantity);
                    if (!$('.mini-cart-tray.tray-popup-visible').length &&
                        (($elem.parents('.product-info').hasClass('bonus-product-line-item') && $('.cart-page').length) ||
                        data.hasBonusProduct)) {
                        location.reload();
                    }
                }
            },
            error: function () {
                $elem.val(parseInt(preSelectQty, 10));
                $.spinner().stop();
            }
        });
    });

    base.selectAttribute();
    base.colorAttribute();
    base.removeBonusProduct();
    base.selectBonusProduct();
    base.enableBonusProductSelection();
    base.showMoreBonusProducts();
    base.focusChooseBonusProductModal();
    base.trapChooseBonusProductModalFocus();
    base.onClosingChooseBonusProductModal();
};
